$(function() {
  // Активируем тултипы
  $('[data-toggle="tooltip"]').tooltip();

  // Добавляем в форму заказа текст из специального атрибута кнопки, вызывающей модальное окно
  $('[data-toggle="modal"]').click(function () {
    let $this = $(this),
      message = $this.data('message');

    $($this.data('target')).find(':input[name="message"]').val(message);
  });

  // Инициализация фильтра грейферов
  $('#grapplesFilter').find(':input').change(function() {
    $(this).closest('form').submit();
  });

  $('[name=driveType]').change(function() {
    if ($(this).val() === '1') {
      $('[name=ropesCount]').attr('disabled', false);
    } else {
      $('[name=ropesCount]').attr('disabled', true);
    }
  });

  if ($(window).width() >= 1200) {
    $('#collapseToggle').click();
  }

  initGrapplesScripts();

  // Инициализация слайдера сертификатов
  $('.certificates-slider').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    speed: 500,
    arrows: false,
    fade: false,
    dots: false,
    swipe: true,
    responsive: [{
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      }
    }],
  });
});

function autoCloseModal(id) {
  setTimeout(() => {
    $(`#${id}Modal`).modal('hide');
    $(`#${id}Modal_forms_flash`).empty();
  }, 3000);
}

function initGrapplesScripts() {
  $('.grapple-item-slider').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: false,
    autoplaySpeed: 5000,
    speed: 500,
    arrows: false,
    fade: false,
    dots: true,
    swipe: true,
    nextArrow: '<button class="slick-arrow next-arrow"><i class="fas fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow prev-arrow"><i class="fas fa-chevron-left"></i></button>'
  });

  $('.grapple-item-images').each(function() {
    $(this).magnificPopup({
      delegate: 'a',
      type: 'image',
      gallery: {
        enabled: true,
      },
    });
  });
}
